document.addEventListener('DOMContentLoaded', () => {
  try {
    const params = new URLSearchParams(window.location.search);
    const sortBy = params.get('sort_by');
    if (!sortBy || (sortBy !== 'price-ascending' && sortBy !== 'price-descending')) return;

    document.querySelectorAll('.buy-together ul[aria-label]').forEach(container => {
      const items = Array.from(container.querySelectorAll('.combo-slide'));
      if (!items.length) return;
      
      const seen = new Set();
      const unique = items.filter(li => {
        const id = li.dataset.comboId || '';
        if (!id) return true;
        if (seen.has(id)) { li.remove(); return false; }
        seen.add(id);
        return true;
      });

      unique.sort((a, b) => {
        const av = parseInt(a.dataset.finalCents || '9999999999', 10);
        const bv = parseInt(b.dataset.finalCents || '9999999999', 10);
        return sortBy === 'price-ascending' ? av - bv : bv - av;
      });

      unique.forEach(li => container.appendChild(li));
    });
  } catch (e) {
    console.error('combo-sort error', e);
  }
});